import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'odq-reclamation-validation-dialog',
    templateUrl: './reclamation-validation-dialog.component.html',
    styleUrls: ['./reclamation-validation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ReclamationValidationDialogComponent  {
 
  constructor(
    public dialogRef: MatDialogRef<ReclamationValidationDialogComponent> 
  ) { 
  } 
  noAnswer() {
    this.dialogRef.close({isReclamationReported: false});
  }
  yesAnswer() {
    this.dialogRef.close({isReclamationReported: true});
  }
}
